import React from 'react';
import {createRoot} from 'react-dom/client';
import AppV2 from './components/app-v2';
import {BrowserRouter} from 'react-router-dom';
import {ProvideAuth} from './components/hooks/use-auth';
import {FatalErrorPage} from './components/navigation/fatal-error-page';
import {CassandraSidePaneProvider} from './components/cassandra/side-pane-context';
import '@amzn/awsui-global-styles/polaris.css';

document.addEventListener('DOMContentLoaded', () => {
    const root = createRoot(document.getElementById('root')!);
    root.render(
        <BrowserRouter>
            <FatalErrorPage>
                <ProvideAuth>
                    <CassandraSidePaneProvider>
                        <AppV2 />
                    </CassandraSidePaneProvider>
                </ProvideAuth>
            </FatalErrorPage>
        </BrowserRouter>
    );
});
